export default {
  'back': [
    {
      'id': 1,
      'name': 'Node.js',
      'icon': 'devicon-nodejs-plain',
      'desc': 'Runtime for API and image processing'
    },
    {
      'id': 2,
      'name': 'Fastify',
      'icon': 'devicon-nodejs-plain',
      'desc': 'High-performance HTTP framework'
    },
    {
      'id': 3,
      'name': 'Prisma',
      'icon': 'devicon-prisma-plain',
      'desc': 'Type-safe ORM and migrations'
    },
    {
      'id': 4,
      'name': 'PostgreSQL',
      'icon': 'devicon-postgresql-plain',
      'desc': 'Main relational data store'
    }
  ],
  'lib': [
    {
      'id': 5,
      'name': 'GraphQL Yoga',
      'link': 'https://the-guild.dev/graphql/yoga-server',
      'desc': '/graphql-yoga'
    },
    {
      'id': 6,
      'name': 'GraphQL Upload',
      'link': 'https://github.com/jaydenseric/graphql-upload',
      'desc': '/graphql-upload'
    },
    {
      'id': 7,
      'name': 'JSON Web Token',
      'link': 'https://github.com/auth0/node-jsonwebtoken',
      'desc': '/jsonwebtoken'
    },
    {
      'id': 8,
      'name': 'Bcrypt',
      'link': 'https://github.com/kelektiv/node.bcrypt.js',
      'desc': '/bcrypt'
    },
    {
      'id': 9,
      'name': 'AWS SDK S3',
      'link': 'https://docs.aws.amazon.com/AWSJavaScriptSDK/v3/latest/client/s3/',
      'desc': '/@aws-sdk/client-s3 (Cloudflare R2 compatible)'
    },
    {
      'id': 10,
      'name': 'Sharp',
      'link': 'https://github.com/lovell/sharp',
      'desc': '/sharp'
    },
  ],
}
